import { render, staticRenderFns } from "./SimpleNew.vue?vue&type=template&id=ffd7335a&"
import script from "./SimpleNew.vue?vue&type=script&lang=js&"
export * from "./SimpleNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports